import { cloudfrontImagesBaseURL } from '../../../components/JobStepper/staticValues';
import { IStep1Form } from '../stepper/Step1/formInterface';
import { IStep2Form } from '../stepper/Step2/formInterfaces';
import { IStep3Form } from '../stepper/Step3/formInterface';
import { IStep4Form } from '../stepper/Step4/formInterface';
import { IStep5Form } from '../stepper/Step5/formInterfaces';

export interface IEditableJobSteps {
  step1: IStep1Form;
  step2: IStep2Form;
  step3: IStep3Form;
  step4: IStep4Form;
  step5: IStep5Form;
}

export const buildEditJobBody = (
  steps: IEditableJobSteps,
  overrides: Partial<IEditableJobSteps> = {}
): IEditableJobSteps => {
  const merged = { ...steps, ...overrides };
  return {
    ...merged,
    step3: {
      ...merged.step3,
      // Yup trims this value before checking it. Send that same value to the API.
      shortDescription: merged.step3.shortDescription?.trim() || null,
    },
    step4: {
      ...merged.step4,
      uploadedLogoPath: merged.step4.uploadedLogoPath?.replace(
        cloudfrontImagesBaseURL,
        ''
      ),
    },
  };
};
